// extracted by mini-css-extract-plugin
module.exports = {"wechat-wrap":"wechat-wrap__jLNQp","wechatWrap":"wechat-wrap__jLNQp","closed-icon":"closed-icon__1e4v_","closedIcon":"closed-icon__1e4v_"};